export let LANGUAGES = [];

/**
 * Fetches the languages list from the server
 * and normalizes it into {code, name}.
 */
export async function loadLanguages() {
  try {
    const res = await fetch('/api/method/zoni_edu.services.languages');
    const json = await res.json();
    // rename name1 → name
    LANGUAGES = json.message.map(({ code, name_en, name_native }) => ({
      code,
      name: `${name_en} — ${name_native}`
    }));
  } catch (err) {
    console.error('Failed to load languages:', err);
  }
}

export function populateLanguageSelects(selectIds = []) {
  selectIds.forEach(id => {
    const sel = document.getElementById(id);
    if (!sel) return;
    // clear the select options
    sel.innerHTML = `<option value="">Select a language</option>`;
    LANGUAGES.forEach(lang => {
      const o = document.createElement("option");
      o.value = lang.code;
      o.textContent = lang.name;
      sel.appendChild(o);
    });
  });
}

// Initialize Select2
export function initLanguageSelect2(ids = []) {
  ids.forEach(id => {
    $(`#${id}`)
      .select2({
        theme: 'bootstrap-5',
        placeholder: "Select a language",
        allowClear: false,
      })
  });
}
